import { render, staticRenderFns } from "./CarrierInfoCard.vue?vue&type=template&id=0e226bc4&scoped=true&"
import script from "./CarrierInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e226bc4",
  null
  
)

export default component.exports